import { COUNTRIES } from '@/forms/constants/onboarding-logic';

const getCountry = countryCode => COUNTRIES.find(country => country.value === countryCode);

export default getCountry;
